import {
	EXPENSE_TYPE_CODES,
	type ExpenseImportFieldConfig,
	type ExpenseImportSystemField,
	type ExpenseImportTypeCode,
} from "../types";
import { REPORT_SUMMARY_CATEGORY_NAMES } from "./expense-report-summary-card";

export const EXPENSE_IMPORT_ALLOWED_EXTENSIONS = [".csv", ".xlsx", ".xls"];

/** Valor do mapeamento quando o usuário escolhe "--Não incluir--" (apenas campos opcionais). */
export const EXPENSE_IMPORT_MAPPING_NONE = "__NONE__";

export const EXPENSE_IMPORT_MAX_ROWS = 100;

export const EXPENSE_IMPORT_MAX_DATA_ROW = EXPENSE_IMPORT_MAX_ROWS + 1;

export const EXPENSE_IMPORT_SYSTEM_FIELD_LABELS: Record<
	ExpenseImportSystemField,
	string
> = {
	Plate: "Placa",
	Amount: "Valor",
	Date: "Data",
	Description: "Observação",
	InfractionNumber: "Número da Infração",
	InfractionDueDate: "Data de Vencimento",
	DriverIdentificationDueDate: "Prazo de Identificação do Condutor",
	MaintenanceType: "Tipo de manutenção",
	ReimbursementReason: "Motivo do reembolso",
	FuelLiters: "Quantidade (litros)",
};

export const EXPENSE_IMPORT_FIELD_CONFIG_BY_TYPE: Record<
	ExpenseImportTypeCode,
	ExpenseImportFieldConfig[]
> = {
	[EXPENSE_TYPE_CODES.Infraction]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
		{
			field: "InfractionNumber",
			label: "Número da Infração",
			isRequired: true,
			value: "AAAAAAAAAAAAA15",
		},
		{
			field: "InfractionDueDate",
			label: "Data de Vencimento",
			isRequired: false,
			value: "18/03/2026",
		},
		{
			field: "DriverIdentificationDueDate",
			label: "Prazo de Identificação do Condutor",
			isRequired: true,
			value: "18/03/2026",
		},
	],
	[EXPENSE_TYPE_CODES.Maintenance]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
		{
			field: "MaintenanceType",
			label: "Tipo de manutenção",
			isRequired: true,
			value: "Corretiva",
		},
	],
	[EXPENSE_TYPE_CODES.Toll]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
	],
	[EXPENSE_TYPE_CODES.Reimbursement]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
		{
			field: "ReimbursementReason",
			label: "Motivo do reembolso",
			isRequired: true,
			value: "Hospedagem",
		},
	],
	[EXPENSE_TYPE_CODES.Fuel]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "FuelLiters",
			label: "Litros",
			isRequired: true,
			value: "38,560",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
	],
	[EXPENSE_TYPE_CODES.Trip]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: false,
			value: "Observação",
		},
	],
	[EXPENSE_TYPE_CODES.Other]: [
		{
			field: "Plate",
			label: "Placa",
			isRequired: true,
			value: "ABC4321",
		},
		{
			field: "Amount",
			label: "Valor",
			isRequired: true,
			value: "BRL 100,00",
		},
		{
			field: "Date",
			label: "Data",
			isRequired: true,
			value: "18/03/2026",
		},
		{
			field: "Description",
			label: "Observação",
			isRequired: true,
			value: "Observação",
		},
	],
};

export const EXPENSE_IMPORT_TYPE_LABELS: Record<ExpenseImportTypeCode, string> =
	REPORT_SUMMARY_CATEGORY_NAMES;

/** Nome da propriedade em validPreview (resposta da API) para cada campo do sistema. */
export const EXPENSE_IMPORT_PREVIEW_ROW_KEY_BY_FIELD: Record<
	ExpenseImportSystemField,
	string
> = {
	Plate: "plate",
	Amount: "amount",
	Date: "date",
	Description: "description",
	InfractionNumber: "infractionNumber",
	InfractionDueDate: "infractionDueDate",
	DriverIdentificationDueDate: "driverIdentificationDueDate",
	MaintenanceType: "maintenanceType",
	ReimbursementReason: "reimbursementReason",
	FuelLiters: "fuelLiters",
};
